import comsStore from '../../state/ComsStore';
export const replaceTooltips = (text) => {
    if (!text)
        return undefined;
    const oDiv = document.createElement('div');
    oDiv.innerHTML = text;
    const allAbbr = oDiv.querySelectorAll('[title]');
    allAbbr.forEach((node) => {
        var _a, _b;
        const div = document.createElement('span');
        div.innerHTML = `<tef-coms-tooltip cloak context="${(_a = comsStore.config) === null || _a === void 0 ? void 0 : _a.styleContext}" placement="bottom">
        ${node.innerHTML}
        <div slot="content">
          ${node.title}
        </div>
      </tef-coms-tooltip>`;
        (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.replaceChild(div.firstChild, node);
    });
    oDiv.querySelectorAll('a').forEach((node) => {
        node.setAttribute('target', '_blank');
    });
    return oDiv.innerHTML;
};
export const localDate = (date) => (date ? new Date(date).toLocaleDateString('de') : null);
export const localTime = (date) => (date ? new Date(date).toLocaleTimeString('de') : null);
//# sourceMappingURL=util.js.map